import { render, staticRenderFns } from "./QuestionSingle.vue?vue&type=template&id=577e8fd7&scoped=true"
import script from "./QuestionSingle.vue?vue&type=script&lang=js"
export * from "./QuestionSingle.vue?vue&type=script&lang=js"
import style0 from "./QuestionSingle.vue?vue&type=style&index=0&id=577e8fd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577e8fd7",
  null
  
)

export default component.exports